<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="onClose()"><ion-icon name="arrow-back-outline" slot="icon-only"> </ion-icon></ion-button>
    </ion-buttons>
    <ion-title>{{ vet.name }} Google Reviews</ion-title>
  </ion-toolbar></ion-header>
<ion-content color="lightmimbo">
  <ion-list>
    <ion-grid>
      <ion-row>
        <ion-col sizeMd="12">
          <ion-item *ngFor="let review of vet.reviews; let i = index; trackBy: trackByAuthor" color="lightmimbo"
            lines="none">
            <ion-card>
              <ion-card-header>
                <div class="author-info">
                  <img class="profile" [src]="review.profilePhotoUrl" referrerpolicy="no-referrer"
                    [attr.loading]="i === 0 ? 'eager' : 'lazy'" [attr.decoding]="i === 0 ? 'auto' : 'async'"
                    (error)="useFallback($event)" />
                  <div>
                    <ion-text class="author">{{ review.authorName }}</ion-text>
                    <div class="review-stars" style="--rating: {{review.rating}}">
                    </div>
                  </div>
                  <ion-card-subtitle class="time">{{ review.time }}</ion-card-subtitle>
                </div>


              </ion-card-header>
              <ion-card-content>
                <p class="review-text" [class.expanded]="review.expanded || !isLong(review.text)">
                  {{ review.text }}
                </p>

                <ion-button color="darkmimbo" *ngIf="isLong(review.text)" fill="clear" size="small"
                  (click)="toggleExpand(review)">
                  {{ review.expanded ? 'See less' : 'See more…' }}
                </ion-button>
              </ion-card-content>
            </ion-card>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>

  </ion-list>
</ion-content>